import { ConciergeAppointmentQuestionFlow } from '~types/concierge-enum'
import { wTrans } from 'laravel-vue-i18n'

export const AppointmentTypeTranslations = {
  [ConciergeAppointmentQuestionFlow.TestDriveAppointment]: wTrans(
    'confirm_appointment_page.types.test_drive'
  ),
  [ConciergeAppointmentQuestionFlow.FreeAppointment]: wTrans(
    'confirm_appointment_page.types.adviser_appointment'
  ),
  [ConciergeAppointmentQuestionFlow.AdviserSelectionAppointment]: wTrans(
    'confirm_appointment_page.types.adviser_appointment'
  )
}
